import * as React from 'react';
import * as H from 'history';
import { Route, RouteProps, RouteComponentProps, Redirect } from 'react-router';
import { observer, inject } from 'mobx-react';
import { IAppStore } from './../../../stores/AllStores';
import { PageForbidden } from './../../../routes/errors';
import { EUserTypeName } from '../../../../../common/interfaces/user';

interface IPrivateRoute extends RouteProps {
    store?: IAppStore;
    authorizedUserTypes?: EUserTypeName[];
}

// Component
@inject('store')
@observer
export class PrivateRoute extends React.Component<IPrivateRoute, {}> {
    constructor(props) {
        super(props);
    }

    private validateRoute = (props: RouteComponentProps<any>): React.ReactNode | undefined => {
        const { store, component, authorizedUserTypes } = this.props;

        if (
            store.user.isLoggedIn &&
            typeof component !== 'undefined' &&
            component !== null &&
            authorizedUserTypes.indexOf(store.user.userType) !== -1
        ) {
            return React.createElement(component as any, props);
        } else {
            return <PageForbidden history={props.history} location={props.location} match={props.match} />;
        }
    };

    public render() {
        // Prepare props
        const { ['store']: deleted, ...newProps } = this.props;

        // Render
        return <Route {...newProps} component={null} render={this.validateRoute} />;
    }
}

export default PrivateRoute;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/route/private/PrivateRoute.tsx